module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-header"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Illustrations#Illustrations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Foreword#Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgments#Ack"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.")]), _vm._v(" Atatürk’s “Üniversite Reformu”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#ch02"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.")]), _vm._v(" The Émigrés")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#ch03"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("3.")]), _vm._v(" The Builders")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#ch04"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("4.")]), _vm._v(" The Preservers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("5.")]), _vm._v(" The Creators")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("6.")]), _vm._v(" The Social Reformers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("7.")]), _vm._v(" The Healers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("8.")]), _vm._v(" The Scientists")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("9.")]), _vm._v(" Problems They Encountered")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("10.")]), _vm._v(" Turbulence Due to WWII")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("11.")]), _vm._v(" Attempts to Emigrate to the US")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("12.")]), _vm._v(" Correspondence")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("13.")]), _vm._v(" Memoirs and Then Some")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("14.")]), _vm._v(" Momentum Lost, Opportunities Foregone—Turkey’s Policies and Practices")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Concluding#Concluding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Remarks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Epilogue#Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix1#appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 1")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contemporary Mission Statements of the Original Three Turkish Universities")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix2#appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 2")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of the Émigré Professors and Their Disciplines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix3#appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 3")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantitative Cross-country Comparisons")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_References#references",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("References")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 78
// module chunks = 0